/* ============================================================================
   BIEN - WHATSAPP LINK: A QR CODE ON COMPUTERS (Max, 2026-10-11)
   ============================================================================
   Drives every link rendered by snippets/bien-wa-pop.liquid (the sold-out
   sign-up's "Follow Bien NYC on WhatsApp" in the strap finder, and the
   footer's #whatsapp row). Most people have WhatsApp on the phone only, so:

   - On a computer (a fine pointer that can hover, asked of matchMedia at the
     moment of each interaction): hovering the words, or tabbing onto them,
     shows a QR code of the channel in a small popover above them (below when
     there is no room above), and a mouse click does nothing (Cmd, Ctrl and
     middle clicks too). Enter, or a screen reader's activate, opens the
     channel in a new tab: tabbing onto the words still shows the code, but
     a link that can't be followed from the keyboard is a dead end.
   - On a phone or tablet the link is left alone: a tap opens the channel in
     the WhatsApp app.

   The QR is drawn the first time it is needed, by the generator the sign-up
   thank-you uses (assets/qr-code-generator.js, whose address each link
   carries in data-bwa-pop), with the thank-you's colours: dark squares on
   the cream tile. The popover lives at the end of <body>, fixed, so nothing
   on the page moves and no section can clip it. It stays open while the
   pointer is on the words or on the popover, and closes on leaving both,
   on blur and on Escape. Loaded as a module, so the footer and the finder
   can both include it and it still runs once.

   The generator is an ES module, loaded by a small module script made at
   the moment of need (load below), never by a dynamic import: Shopify's CDN
   minifies this file and rewrites a dynamic import into require(), which
   browsers don't have (2026-10-11). If the generator can't load (blocked,
   offline, or 15 s without an answer), no popover shows and the words are a
   plain link again: a click opens the channel in a new tab. Nothing is
   final: a later hover or focus tries again (a fresh address after a failed
   fetch, which the browser would otherwise remember as failed), and a code
   that arrives late, while the words are still pointed at, shows at once.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__bienWaPop) return;
  window.__bienWaPop = 1;

  var SEL = 'a[data-bwa-pop]';
  var MQ = '(hover: hover) and (pointer: fine)';
  var GAP = 10;     /* between the words and the popover */
  var EDGE = 8;     /* the least room kept to the edge of the window */
  var LINGER = 120; /* ms to cross from the words to the popover */
  var CSS =
    '.bwa-pop{position:fixed;left:0;top:0;z-index:2147482000;box-sizing:border-box;width:172px;padding:12px;' +
    'border:1px solid #5a4a24;border-radius:12px;background:#17140f;color:#cfc3ad;' +
    'box-shadow:0 14px 36px rgba(0,0,0,.45);font-family:var(--bien-ff-body,Georgia,serif);text-align:center;' +
    'opacity:0;visibility:hidden;pointer-events:none;transform:translateY(4px);' +
    'transition:opacity .14s ease-in,transform .14s ease-in,visibility 0s linear .14s}' +
    '.bwa-pop[data-side=bottom]{transform:translateY(-4px)}' +
    '.bwa-pop.is-open{opacity:1;visibility:visible;pointer-events:auto;transform:none;' +
    'transition:opacity .16s cubic-bezier(.16,1,.3,1),transform .16s cubic-bezier(.16,1,.3,1),visibility 0s}' +
    '.bwa-pop__qr{box-sizing:border-box;width:132px;height:132px;margin:0 auto;padding:8px;background:#f2ead9;border-radius:6px}' +
    '.bwa-pop__qr svg{display:block;width:100%;height:100%}' +
    /* padding, not margin: base.css zeroes the top margin of a <p> after an
       empty first child, which the tile is until its code arrives */
    '.bwa-pop__line{margin:0;padding:10px 0 0;color:#cfc3ad;font-family:var(--bien-ff-body,Georgia,serif);font-size:12px;line-height:1.45;letter-spacing:.01em;text-transform:none;hyphens:manual;word-break:normal}' +
    '.bwa-pop__line[hidden]{display:none}' +
    '@media (prefers-reduced-motion:reduce){.bwa-pop,.bwa-pop.is-open,.bwa-pop[data-side=bottom]{transition:none;transform:none}}';

  var pop = null, tile = null, line = null;
  var cur = null;          /* the link the popover belongs to */
  var tileUrl = null;      /* the channel address whose code is in the tile */
  var overLink = false, overPop = false, kbd = false;
  var hideT = 0, raf = 0, n = 0;
  var failed = false;      /* the last try at the generator failed: no popover, a plain link */
  var qrs = {};            /* channel address -> its drawn <svg> */
  var gen = null;          /* the generator, once it has arrived */
  var loading = null;      /* the try in flight */
  var finish = null;       /* ends the try in flight */
  var bust = 0;            /* fetches that failed outright */

  /* the generator arrived, in time or late */
  function got(m) {
    var late = failed;
    if (!gen) gen = m;
    failed = false;
    window.__bienWaGen = null;
    if (finish) finish();
    /* after a time-out or a failed try: shown now if the words are still
       pointed at or focused */
    if (late && cur && (overLink || kbd)) open(cur);
  }

  /* the generator (an ES module) through a module script made here: its text
     is a string, which the CDN's minifier leaves alone. One try at a time;
     after a time-out window.__bienWaGen stays, so a late arrival still counts. */
  function load(src) {
    if (gen) return Promise.resolve(gen);
    if (loading) return loading;
    /* a failed fetch is remembered by its address: a retry asks for a new one */
    var url = bust ? src + (src.indexOf('?') < 0 ? '?' : '&') + 'bwa=' + bust : src;
    loading = new Promise(function (res, rej) {
      var s = document.createElement('script'), done = false, t = 0;
      function end(err) {
        if (done) return;
        done = true; clearTimeout(t); loading = finish = null;
        if (s.parentNode) s.parentNode.removeChild(s);
        if (gen) res(gen); else rej(err || new Error('load'));
      }
      finish = end;
      t = setTimeout(function () { end(new Error('timeout')); }, 15000);
      window.__bienWaGen = got;
      s.type = 'module';
      s.textContent = 'import * as m from ' + JSON.stringify(url) + ';window.__bienWaGen&&window.__bienWaGen(m);';
      s.onerror = function () { bust++; end(new Error('load')); };
      document.head.appendChild(s);
    });
    return loading;
  }

  function fine() {
    try { return !!(window.matchMedia && window.matchMedia(MQ).matches); } catch (e) { return false; }
  }
  function linkOf(t) { return t && t.closest ? t.closest(SEL) : null; }
  function inPop(t) { return !!(pop && t && (t === pop || pop.contains(t))); }
  function isOpen() { return !!(pop && pop.classList.contains('is-open')); }

  function build() {
    if (pop) return;
    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);
    pop = document.createElement('div');
    pop.className = 'bwa-pop';
    /* the words carry the description (aria-describedby); this is the picture of it */
    pop.setAttribute('aria-hidden', 'true');
    tile = document.createElement('div');
    tile.className = 'bwa-pop__qr';
    line = document.createElement('p');
    line.className = 'bwa-pop__line';
    pop.appendChild(tile);
    pop.appendChild(line);
    document.body.appendChild(pop);
  }

  function put(url) {
    if (!cur || cur.getAttribute('href') !== url || !qrs[url]) return;
    if (tileUrl === url) return;
    tile.textContent = '';
    tile.appendChild(qrs[url]);
    tileUrl = url;
    if (isOpen()) place(); /* placed while the tile was empty */
  }

  function draw(a) {
    var url = a.getAttribute('href');
    if (qrs[url]) { put(url); return; }
    load(a.getAttribute('data-bwa-pop')).then(function (m) {
      if (!qrs[url]) {
        var box = document.createElement('div');
        /* the thank-you's settings (snippets/bien-wa-follow.liquid) */
        new m.QRCode(box, {
          text: url, width: 240, height: 240,
          colorDark: '#151412', colorLight: '#f2ead9',
          correctLevel: 2, useSVG: true /* H: the Bien star covers the middle (Max, 2026-10-14) */
        });
        var svg = box.querySelector('svg');
        if (!svg) throw new Error('no QR');
        /* the generator names its square "template"; give this code its own
           id so it never borrows the thank-you QR's squares, or lends its own */
        var id = 'bwa-pop-q-' + (++n);
        var tpl = svg.querySelector('#template');
        if (tpl) {
          tpl.setAttribute('id', id);
          var uses = svg.querySelectorAll('use');
          for (var i = 0; i < uses.length; i++) uses[i].setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + id);
        }
        /* the Bien star in the middle (assets/bien-qr-star.js) */
        if (window.bienQrStar) window.bienQrStar(svg, { light: '#f2ead9', dark: '#151412' });
        qrs[url] = svg;
      }
      put(url);
    }).catch(function () {
      /* no code: no popover and a plain link, until a later try works */
      failed = true;
      clearTimeout(hideT);
      if (pop) pop.classList.remove('is-open');
    });
  }

  /* returns false (and closes) when the words are no longer on the page */
  function place() {
    raf = 0;
    if (!cur || !pop) return false;
    var r = cur.getBoundingClientRect();
    if (!cur.isConnected || (!r.width && !r.height)) { close(); return false; }
    var de = document.documentElement;
    var vw = de.clientWidth || window.innerWidth, vh = de.clientHeight || window.innerHeight;
    var w = pop.offsetWidth, h = pop.offsetHeight;
    var side = 'top', top = r.top - GAP - h;
    if (top < EDGE) {
      var below = r.bottom + GAP;
      if (below + h <= vh - EDGE || vh - r.bottom > r.top) { side = 'bottom'; top = below; }
    }
    top = Math.max(EDGE, Math.min(top, vh - EDGE - h));
    var left = Math.max(EDGE, Math.min(r.left + r.width / 2 - w / 2, vw - EDGE - w));
    pop.style.left = Math.round(left) + 'px';
    pop.style.top = Math.round(top) + 'px';
    pop.setAttribute('data-side', side);
    return true;
  }

  function open(a) {
    clearTimeout(hideT);
    build();
    if (a !== cur) {
      cur = a;
      var t = a.getAttribute('data-bwa-pop-line') || '';
      line.textContent = t;
      line.hidden = !t;
    }
    if (tileUrl !== a.getAttribute('href')) { tile.textContent = ''; tileUrl = null; }
    draw(a);
    /* the last try failed: this one runs unseen, and got() opens the
       popover if it works while the words are still pointed at */
    if (failed) return;
    if (!place()) return;
    if (!isOpen()) {
      void pop.offsetWidth; /* start the fade from the placed, clear state */
      pop.classList.add('is-open');
    }
  }

  function close() {
    clearTimeout(hideT);
    overLink = overPop = kbd = false;
    if (pop) pop.classList.remove('is-open');
  }

  function later() {
    clearTimeout(hideT);
    hideT = setTimeout(function () { if (!overLink && !overPop && !kbd) close(); }, LINGER);
  }

  document.addEventListener('mouseover', function (e) {
    var a = linkOf(e.target);
    if (a) {
      if (linkOf(e.relatedTarget) === a) return;
      if (!fine()) return;
      overLink = true;
      open(a);
    } else if (inPop(e.target) && isOpen()) {
      overPop = true;
      clearTimeout(hideT);
    }
  }, true);

  document.addEventListener('mouseout', function (e) {
    var to = e.relatedTarget, a = linkOf(e.target);
    if (a) {
      if (linkOf(to) === a || a !== cur) return;
      overLink = false;
    } else if (inPop(e.target)) {
      if (inPop(to)) return;
      overPop = false;
    } else return;
    if (isOpen()) later();
  }, true);

  document.addEventListener('focusin', function (e) {
    var a = linkOf(e.target);
    if (!a || !fine()) return;
    var shown = true;
    try { shown = a.matches(':focus-visible'); } catch (x) { /* no :focus-visible: every focus counts */ }
    if (!shown) return; /* focus from a mouse click: the hover rules apply */
    open(a);
    kbd = true;
  }, true);

  document.addEventListener('focusout', function (e) {
    if (!kbd || linkOf(e.target) !== cur) return;
    kbd = false;
    if (!overLink && !overPop) close();
  }, true);

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && isOpen()) close();
  }, true);

  /* On a computer a mouse click only shows the code: no page, no new tab.
     When the code can't be drawn, the words are a plain link to the channel.
     A click from the keyboard (Enter) or from a screen reader's activate
     carries no mouse press (detail 0) and opens the channel in a new tab. */
  function onClick(e) {
    var a = linkOf(e.target);
    if (!a || failed || !fine()) return;
    if (e.type === 'click' && e.detail === 0) return;
    e.preventDefault();
    if (e.type === 'click') open(a);
  }
  document.addEventListener('click', onClick, true);
  document.addEventListener('auxclick', onClick, true);

  function onMove() { if (isOpen() && !raf) raf = requestAnimationFrame(place); }
  window.addEventListener('scroll', onMove, { capture: true, passive: true });
  window.addEventListener('resize', onMove);

  /* The description ("QR code for ...") belongs to computers only. */
  function aria() {
    var f = fine(), links = document.querySelectorAll(SEL);
    for (var i = 0; i < links.length; i++) {
      var a = links[i], d = a.getAttribute('data-bwa-pop-d');
      if (d === null) { d = a.getAttribute('aria-describedby') || ''; a.setAttribute('data-bwa-pop-d', d); }
      if (f && d) a.setAttribute('aria-describedby', d);
      else a.removeAttribute('aria-describedby');
    }
  }
  aria();
  try {
    var mq = window.matchMedia(MQ);
    if (mq.addEventListener) mq.addEventListener('change', aria);
    else if (mq.addListener) mq.addListener(aria);
  } catch (e) { /* no matchMedia: the links stay plain */ }
})();
